import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import "./BankDetailModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";
import * as _ from "lodash";
import Loader from "../../../Lottifiers/Loader/Loader";
import Compdirection from "../../../themes/CompDirection";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackSubmit: (data: any) => void;
  selectedEmployeeDetail?: any;
  isLoading: boolean;
  trans?: any;
  bankInfoData?: any;
  payout_types?: any;
  fields_of_exchange?: any;
  fields_of_banks?: any;

  exchangeNameList?: any;
  bankNameList?: any;
}

const PopupModalPresenter = ({
  isModalOpen,
  closeModal,
  isLoading,
  callBackSubmit,
  trans,
  bankInfoData,
  payout_types,
  fields_of_banks,
  fields_of_exchange,
  bankNameList,
  exchangeNameList,
}: ModalProps) => {
  //for upating
  const [bankVal, setBankVal] = useState<any>();
  const [exchangeVal, setExchangeVal] = useState<any>();

  const [bankAll, setBankAll] = useState<any>([]);
  const [exchangeAll, setExchangeAll] = useState<any>([]);

  const [p_type, setp_type] = useState("");
  const [p_typeId, setp_typeId] = useState("");

  const [exchange_agentId, setExchange_agentId] = useState<any>("");
  const [bank_agentId, setBank_agentId] = useState<any>("");

  useEffect(() => {
    const bankDetailsArray = bankInfoData?.bankdetails
      ? Object.entries(bankInfoData?.bankdetails).map(([key, value]) => {
          return { field_name: key, value };
        })
      : [];
    setBankVal(bankDetailsArray);

    const exchangeDetailsArray = bankInfoData?.exchange
      ? Object.entries(bankInfoData?.exchange).map(([key, value]) => {
          return { field_name: key, value };
        })
      : [];
    setExchangeVal(exchangeDetailsArray);
  }, [bankInfoData]);
  useEffect(() => {
    if (p_typeId == "1") {
      const bankDetailsArray = bankInfoData?.bankdetails
        ? Object.entries(bankInfoData?.bankdetails).map(([key, value]) => {
            key == "bank_routing_no" ? setBank_agentId(value) : "";
            return { key, value };
          })
        : [];
      setExchangeAll([]);
      if (bankDetailsArray?.length > 0) {
        setBankAll(bankDetailsArray);
      } else {
        const temp: any = [];
        const temp_edit: any = [];
        fields_of_banks.map((b: any) => {
          const obj = {
            key: b?.field_name,
            value: "",
          };
          const obj_2 = {
            field_name: b?.field_name,
            value: "",
          };
          temp.push(obj);
          temp_edit.push(obj_2);
        });
        setBankVal(temp_edit);
        setBankAll(temp);
      }
    } else if (p_typeId == "2") {
      const exchangeDetailsArray = bankInfoData?.exchange
        ? Object.entries(bankInfoData?.exchange).map(([key, value]) => {
            key == "agent_id" ? setExchange_agentId(value) : "";

            return { key, value };
          })
        : [];
      setBankAll([]);

      if (exchangeDetailsArray?.length > 0) {
        setExchangeAll(exchangeDetailsArray);
      } else {
        const temp: any = [];
        const temp_edit: any = [];
        fields_of_exchange.map((b: any) => {
          const obj = {
            key: b?.field_name,
            value: "",
          };
          const obj_2 = {
            field_name: b?.field_name,
            value: "",
          };
          temp.push(obj);
          temp_edit.push(obj_2);
        });
        setExchangeVal(temp_edit);
        setExchangeAll(temp);
      }
    }
  }, [p_typeId]);

  const handleSubmit = () => {
    const payload: any = [];
    if (p_typeId == "1") {
      bankVal.forEach((e: any) => {
        const jsonobj: any = {};
        jsonobj[e.field_name] =
          e.field_name == "bank_routing_no" ? bank_agentId : e.value;
        payload.push(jsonobj);
      });
    } else if (p_typeId == "2") {
      exchangeVal.forEach((e: any) => {
        const jsonobj: any = {};
        jsonobj[e.field_name] =
          e.field_name == "agent_id" ? exchange_agentId : e.value;
        payload.push(jsonobj);
      });
    }

    callBackSubmit({
      fields: payload,
      payoutypeID: p_typeId,
    });
  };
  const getAgentId = (name: string, src: string) => {
    let bank_rzlt: any = "";
    let exchange_rzlt: any = "";
    if (src == "bank") {
      bank_rzlt = bankNameList.filter((b: any) => {
        return b?.name == name;
      });
      setBank_agentId(bank_rzlt[0]?.agent_id);
    } else if (src == "exchange") {
      exchange_rzlt = exchangeNameList.filter((b: any) => {
        return b?.name == name;
      });
      setExchange_agentId(exchange_rzlt[0]?.agent_id);
    }
  };
  const handleBankFields = (newVal: any, i: any) => {
    const temp_array = [...bankVal];
    const tempObj = { ...temp_array[i] };
    tempObj["value"] = newVal;
    temp_array[i] = tempObj;
    setBankVal(temp_array);

    const final_array: any = [];
    temp_array.map((x: any) => {
      const obj = {
        key: x?.field_name,
        value: x?.field_name == "bank_routing_no" ? bank_agentId : x?.value,
      };
      final_array.push(obj);
    });
    setBankAll(final_array);
  };

  const handleExchangeFields = (newVal: any, i: any) => {
    const temp_array = [...exchangeVal];
    const tempObj = { ...temp_array[i] };
    tempObj["value"] = newVal;
    temp_array[i] = tempObj;
    setExchangeVal(temp_array);

    const final_array: any = [];
    temp_array.map((x: any) => {
      const obj = {
        key: x?.field_name,
        value: x?.field_name == "agent_id" ? exchange_agentId : x?.value,
      };
      final_array.push(obj);
    });
    setExchangeAll(final_array);
  };

  const handleSetPayoutType = (payout__name: any) => {
    const filtered__payout = _.filter(payout_types, function (g: any) {
      return g.name === payout__name;
    });
    if (filtered__payout.length) {
      const gndr = filtered__payout[0];
      setp_typeId(gndr.id);
      setp_type(payout__name);
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="600px"
      overflowY={"auto"}
    >
      <ModalHeader
        modal={{ modal_title: trans("Edit Bank") }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "20px",
          }}
        >
          {isLoading ? (
            <Loader height={100} width={200} />
          ) : (
            <>
              <Grid item xs={6}>
                <CustomAutoComplete
                  label={trans("Payout")}
                  options={_.map(payout_types, (data: any) => {
                    return data.name;
                  })}
                  value={p_type}
                  onChange={(event: any, newValue: any) => {
                    handleSetPayoutType(newValue);
                  }}
                />
              </Grid>
              {_.map(bankAll, (bank: any, i: any) => {
                return _.map(fields_of_banks, (f: any) => {
                  if (
                    f?.field_name == bank?.key &&
                    f?.field_name != "bank_name" &&
                    f?.field_name != "bank_routing_no"
                  ) {
                    return (
                      <Grid item xs={6}>
                        <CustomTextField
                          type="string"
                          label={trans(f?.name)}
                          defaultValue={bank.value}
                          onChange={(e: any) =>
                            handleBankFields(e.target.value, i)
                          }
                        />
                      </Grid>
                    );
                  } else if (
                    f?.field_name == bank?.key &&
                    f?.field_name == "bank_routing_no"
                  ) {
                    return (
                      <Grid item xs={6}>
                        <CustomTextField
                          type="string"
                          label={trans(f?.name)}
                          value={bank_agentId}
                          disabled
                        />
                      </Grid>
                    );
                  } else if (
                    f?.field_name == bank?.key &&
                    f?.field_name == "bank_name"
                  ) {
                    return (
                      <Grid item xs={6}>
                        <CustomAutoComplete
                          label={trans(f?.name)}
                          options={_.map(bankNameList, (ex: any) => {
                            return ex.name;
                          })}
                          value={bank.value}
                          onChange={(event: any, newValue: any) => {
                            getAgentId(newValue, "bank");
                            handleBankFields(newValue, i);
                          }}
                        />
                      </Grid>
                    );
                  }
                });
              })}
              {_.map(exchangeAll, (ex: any, i: any) => {
                return _.map(fields_of_exchange, (f: any) => {
                  if (
                    f?.field_name == ex?.key &&
                    f?.field_name != "bank_name" &&
                    f?.field_name != "agent_id"
                  ) {
                    return (
                      <Grid item xs={6}>
                        <CustomTextField
                          type="string"
                          label={trans(f?.name)}
                          defaultValue={ex.value}
                          onChange={(e: any) =>
                            handleExchangeFields(e.target.value, i)
                          }
                        />
                      </Grid>
                    );
                  } else if (
                    f?.field_name == ex?.key &&
                    f?.field_name == "agent_id"
                  ) {
                    return (
                      <Grid item xs={6}>
                        <CustomTextField
                          type="string"
                          label={trans(f?.name)}
                          value={exchange_agentId}
                          disabled
                        />
                      </Grid>
                    );
                  } else if (
                    f?.field_name == ex?.key &&
                    f?.field_name == "bank_name"
                  ) {
                    return (
                      <Grid item xs={6}>
                        <CustomAutoComplete
                          clearOnBlur={false}
                          label={f?.name}
                          options={_.map(exchangeNameList, (ex: any) => {
                            return ex.name;
                          })}
                          value={ex.value}
                          onChange={(event: any, newValue: any) => {
                            getAgentId(newValue, "exchange");
                            handleExchangeFields(newValue, i);
                          }}
                        />
                      </Grid>
                    );
                  }
                });
              })}
            </>
          )}
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default PopupModalPresenter;
